import { RoleReference } from "../domain";
import { GroupTransaction } from "../store";

export interface UpdateGroupInput {
  name: string;
  roles: RoleReference[];
}

export type UpdateGroupCommand = (
  uuid: string,
  updated: UpdateGroupInput,
) => Promise<void>;

interface CommandProps {
  transaction: GroupTransaction;
}

export const UpdateGroupCommand =
  ({ transaction }: CommandProps): UpdateGroupCommand =>
  (uuid, updated) =>
    transaction(async (retrieve, persist) => {
      const group = await retrieve(uuid);

      await persist({
        ...group,
        name: updated.name,
        roles: updated.roles,
        updatedAt: new Date(),
      });
    });
